import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { VendorDocument } from '../../../../../models/VendorDocument';
import { DataService } from '../../../../../services/data.service';
import { VendorService } from '../../../../../services/vendor.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { ConfirmationPageSuccessComponent } from '../../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../../../shared-components/busy-indicator/busy-indicator.component';
import { Code } from '../../../../../models/Code';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-submit-vendor-invoice',
  templateUrl: './submit-vendor-invoice.component.html',
  styleUrls: ['./submit-vendor-invoice.component.scss']
})
export class SubmitVendorInvoiceComponent implements OnInit, OnDestroy {
  vendorInv: VendorDocument = new VendorDocument();
  openPOList: Code[] = [];
  gpVID = '';
  currency = '';
  errorMsg: string;
  successMsg: string;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  reader: FileReader = new FileReader();
  filename: string;
  fileData: Uint8Array;
  isFileInvalid: boolean;
  fileInputErrorMsg: string;
  alive = true;
  @ViewChild('fileInput') fileInput: any;
  @ViewChild('txtInvAmt') txtInvAmt: ElementRef;
  constructor(private dataSvc: DataService,
    private vendorSvc: VendorService,
    private spinner: NgxSpinnerService) {
      this.currency = dataSvc.userDisplayInfo.Currency;
      this.gpVID = dataSvc.userDisplayInfo.GPVID;
    }

  ngOnInit() {
    this.getOpenPOList();
  }
  onlyDecimalNumberKey(event) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
        && (charCode < 48 || charCode > 57))
        return false;
    return true;
}
  sanitizeAmount(amt: string) {
    if (amt) {
      let newAmt = amt.replace(',', '');
      newAmt = newAmt.replace('$', '');
      if (newAmt !== '') {
        try {
        this.txtInvAmt.nativeElement.value = parseFloat(newAmt).toFixed(2);
        } catch {
          console.log(newAmt);
          this.txtInvAmt.nativeElement.value='';
        }
      } else {
        this.txtInvAmt.nativeElement.value = '';
      }
    }
  }

  getOpenPOList() {
    this.vendorSvc.getOpenPOs(this.gpVID)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = true;
        this.errorMsg = null;
        this.successMsg = null;
        this.openPOList = data;
      }
    );
  }

  checkInvoiceNumber(frmSubmitInvoice: NgForm) {
    if (this.vendorInv.InvoiceNumber && this.vendorInv.InvoiceNumber !== '') {
      this.vendorSvc.checkInvoiceNumber(this.vendorInv.InvoiceNumber, this.gpVID)
          .takeWhile(() => this.alive)
          .subscribe(
            data => {
                      if (data === true) {
                        frmSubmitInvoice.controls['vendorInv.InvoiceNumber'].setErrors({'incorrect' : true});
                      } else {
                        frmSubmitInvoice.controls['vendorInv.InvoiceNumber'].setErrors(null);
                      }
          }
      );
    }
  }

  onSubmit() {
    this.vendorInv.Currency = this.currency;
    this.vendorInv.GPVID = this.gpVID;
    if (this.filename) {
      this.spinner.show();
      this.vendorInv.FileName = this.filename;
      this.vendorInv.FileData = this.arrayBufferToBase64(this.fileData);

        this.vendorSvc.submitInvoice(this.vendorInv)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          this.showFailConfirmation = false;
          this.showSuccessConfirmation = true;
          this.errorMsg = null;
          this.successMsg = 'Your have successfully submitted an invoice.';
          console.log(data);
        },
        err => {
          this.spinner.hide();
          this.vendorInv = null;
          console.log(err);
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;
          this.errorMsg = 'Failed to submit invoice.';
        }
      );
    } else {
      this.isFileInvalid = true;
      this.fileInputErrorMsg = 'Please uplodad the invoice document.';
    }
  }

  clearData() {
    this.filename = null;
    this.vendorInv = new VendorDocument();
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  readFile(files: FileList) {
    this.reader.onload = e => {
     this.fileData = new Uint8Array(this.reader.result);
    };
    console.log(files[0]);
    this.reader.readAsArrayBuffer(files[0]);
  }

  arrayBufferToBase64(buffer: Uint8Array): string {
    let binary = '';
    const len = buffer.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(buffer[i]);
    }
    return btoa(binary);
  }

  checkFileExt(fileExt: string): boolean {
    // tslint:disable-next-line:max-line-length
    if (!fileExt.match(/.jpg|.jpeg|.bmp|.png|.gif|.tiff|.pdf|.doc|.docx|.xls|.xlsx|.JPG|.JPEG|.BMP|.PNG|.GIF|.TIFF|.PDF|.DOC|.DOCX|.XLS|.XLSX/i)) {
      return false;
    }
    return true;
  }

  async handleFileInput(files: FileList) {
    this.isFileInvalid = false;
    if (files.length !== 1) {
      this.fileInput.nativeElement.value = '';
      return;
    }

    if (files[0].size > 5242880) {
      this.fileInputErrorMsg = "This file's size exceeds the limit";
      this.isFileInvalid = true;
      this.fileInput.nativeElement.value = '';
      return;
    }

    const fileExt = files[0].name.substring(files[0].name.lastIndexOf('.')).toLowerCase();

    if (!this.checkFileExt(fileExt)) {
      console.log('Unsupport this kind of file');
      this.fileInputErrorMsg = "We don't support " + fileExt + " file";
      this.isFileInvalid = true;
      this.fileInput.nativeElement.value = '';
      return;
    }
    this.filename = files[0].name;
    this.readFile(files);
  }


  ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/invoices-view/submit-vendor-invoice/submit-vendor-invoice.component.ts